/* eslint-disable react/destructuring-assignment */
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useLogger } from "src/providers/LoggerProvider"
import { snackbarErrorHandler } from "src/utils/errorHandler"
import { RequestError } from "src/models/errors"
import { useInterval } from "src/utils/useInterval"
import { Assignment, getAssignments } from "./myassignments"
import Browser from "src/components/browser/Browser"
import BrowserCard from "src/components/browser/card/BrowserCard"
import { BrowserCardLabel } from "src/components/browser/card/BrowserCardLabel"
import OpenInEditorButton from "src/components/browser/buttons/OpenInEditorButton"
import { StageType } from "@models/common"
import Deadline from "src/components/browser/typography/Deadline"
import { useSnackbar } from "src/providers/SnackbarProvider"
import { useTheme } from "@mui/material"

const LIMIT = 6

const AssignmentsBrowser = () => {
  const { snackbarShowMessage } = useSnackbar()
  const [assignments, setAssignment] = useState<Assignment[] | null>(null)
  const [totalCount, setTotalCount] = useState<number>(0)
  const [activePage, setActivePage] = useState<number>(0)

  const { t } = useTranslation('common')
  const { logger } = useLogger()
  const { palette } = useTheme()
  const fetchData = async () => {
    if (document.visibilityState == "hidden") return
    try {
      const { totalCount, results } = await getAssignments(activePage * LIMIT, LIMIT)
      setAssignment(results)
      setTotalCount(totalCount)
    } catch (e) {
      if (e instanceof RequestError && e.status !== 403) {
        snackbarErrorHandler(e, { snackbarShowMessage }, t)
      }
      logger.error("System - Failed to fetch assignments", e)
    }
  }

  useEffect(() => { fetchData() }, [activePage])
  useInterval(fetchData, 10000)

  return (
    <Browser
      browserTitle={t('assignments.title')}
      noDataMessage={t('assignments.noData')}
      onPageChange={(activePage => setActivePage(activePage))}
      totalCount={totalCount}>
      {assignments && assignments.map(assignment =>
        <BrowserCard
          key={assignment.assignmentId}
          title={assignment.jobName}
          button={<OpenInEditorButton assignmentId={assignment.assignmentId} />}
          cardColor={'primary'}
          label={<BrowserCardLabel
            label={getLabelAssignmentType(assignment.assignmentType)}
            labelBackgroundColor={palette.primary.main}
            labelTextColor={palette.primary.contrastText} />}
        >
          <Deadline dueDate={assignment.dueDate} />
        </BrowserCard>
      )}
    </Browser>
  )
}

function getLabelAssignmentType(assignmentType: StageType) {
  switch (assignmentType) {
    case 'TRUST_MINING': return 'Trust Mining'
    case 'ENHANCEMENT': return 'Enhancement'
    case 'CORRECTION': return 'Correction'
    default: return 'Assignment'
  }
}

export default AssignmentsBrowser
